import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  { name: "full_name", label: "Name", required: true, showInTable: true },
  { name: "mobile", label: "Mobile", required: true, showInTable: true },
  { name: "alt_mobile", label: "Alt Mobile" },
  { name: "email", label: "Email", type: "email" },
  { name: "address", label: "Address", type: "textarea" },
  { name: "city", label: "City", showInTable: true },
  { name: "area", label: "Area" },
  { name: "pincode", label: "Pincode" },
  { name: "tiffin_count", label: "Tiffin Count", type: "number" },
  {
    name: "meal_type",
    label: "Meal Type",
    type: "select",
    options: [
      { value: "lunch", label: "Lunch" },
      { value: "dinner", label: "Dinner" },
      { value: "both", label: "Both" },
    ],
  },
  { name: "start_date", label: "Start Date", type: "date" },
  { name: "delivery_address", label: "Delivery Address", type: "textarea" },
  {
    name: "special_instructions",
    label: "Special Instructions",
    type: "textarea",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "new", label: "New" },
      { value: "contacted", label: "Contacted" },
      { value: "approved", label: "Approved" },
      { value: "active", label: "Active" },
      { value: "closed", label: "Closed" },
    ],
    showInTable: true,
  },
];

export default function Page() {
  return (
    <AdminShell title="Tiffin Requests" subtitle="From public website">
      <ResourceTable
        table="tiffin_requests"
        title="Tiffin Request"
        fields={fields}
        searchFields={["full_name", "mobile", "city"]}
      />
    </AdminShell>
  );
}
